var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLionUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D26437"
    },
    d: "M256.005,12.733c2.886-0.001,5.772-0.767,8.372-2.298C272.375,5.726,286.098,0,305.547,0 c37.319,0,66.067,16.516,66.067,16.516l-16.516,16.516c17.752,4.734,27.871,7.57,47.369,17.786 c68.569,35.927,101.276,114.343,101.276,114.343h-33.032C512,231.226,512,322.065,512,322.065l-24.774-8.258 c0,0,0,74.323-33.032,123.871l-24.774-16.516c0,0-24.774,41.29-66.065,66.065l-16.516-16.516c0,0-41.29,33.032-90.839,41.29 c-49.548-8.258-90.839-41.29-90.839-41.29l-16.516,16.516c-41.29-24.774-66.065-66.065-66.065-66.065l-24.774,16.516 C24.775,388.13,24.775,313.807,24.775,313.807l-24.774,8.258c0,0,0-90.839,41.29-156.903H8.259c0,0,32.707-78.416,101.276-114.343 c19.498-10.216,29.617-13.052,47.369-17.786l-16.516-16.516c0,0,28.747-16.516,66.067-16.516c19.449,0,33.172,5.726,41.17,10.436 c2.6,1.531,5.486,2.297,8.372,2.298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B44632"
    },
    d: "M187.22,91.077c0,0,23.877-48.754,64.061-79.097c-1.255-0.379-2.491-0.858-3.657-1.544 C239.627,5.726,225.904,0,206.455,0c-37.319,0-66.067,16.516-66.067,16.516l16.516,16.516c-17.752,4.734-27.871,7.57-47.369,17.786 C40.966,86.745,8.259,165.161,8.259,165.161h33.032c-41.29,66.065-41.29,156.904-41.29,156.904l24.774-8.258 c0,0,0,74.323,33.032,123.871l24.774-16.516c0,0,24.774,41.29,66.065,66.065l16.516-16.516c0,0,41.29,33.032,90.839,41.29 C256.001,512,196.13,487.226,187.22,91.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M410.232,50.111c19.546-3.79,37.454,12.093,35.567,31.913c-2.343,24.606-20.422,67.997-45.196,93.546 l-79.57-80.086C351.522,71.282,389.392,54.152,410.232,50.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E18C46"
    },
    d: "M342.607,117.198c25.356-19.382,62.841-44.879,73.223-45.922 c11.932-1.199,19.371,15.26,14.706,33.023c-4.05,15.422-19.498,43.71-34.876,66.296L342.607,117.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M101.77,50.111c-19.546-3.79-37.454,12.093-35.567,31.913c2.343,24.606,20.422,67.997,45.196,93.546 l79.57-80.086C160.48,71.282,122.61,54.152,101.77,50.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E18C46"
    },
    d: "M169.395,117.198c-25.356-19.382-62.841-44.879-73.223-45.922 c-11.932-1.199-19.371,15.26-14.706,33.023c4.05,15.422,19.498,43.71,34.876,66.296L169.395,117.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M355.098,99.097c-32.593-25.35-99.097,16.516-99.097,16.516s-66.504-41.866-99.097-16.516 c-74.323,57.806-90.839,222.968-82.581,256c6.009,24.034,57.806,66.065,115.613,82.581h132.129 c57.806-16.516,109.604-58.546,115.613-82.581C445.936,322.065,429.42,156.903,355.098,99.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M125.236,403.816c-6.343-39.607,8.658-215.343,61.984-312.739c-11.211-0.54-21.899,1.473-30.316,8.02 c-74.323,57.806-90.839,222.968-82.581,256c3.617,14.469,23.889,35.439,52.017,53.458 C125.916,406.944,125.478,405.326,125.236,403.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAEBC8"
    },
    d: "M437.678,313.701c-6.009,24.034-57.806,66.065-115.613,82.581H189.936 c-57.806-16.516-109.604-58.546-115.613-82.581c-0.376-1.501-0.68-3.363-0.95-5.388c-1.635,21.488-1.146,38.401,0.95,46.784 c6.009,24.034,57.806,66.065,115.613,82.581h132.129c57.806-16.516,109.604-58.546,115.613-82.581 c2.096-8.383,2.585-25.296,0.95-46.784C438.359,310.337,438.054,312.199,437.678,313.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5DCB4"
    },
    d: "M187.462,424.27c4.287,26.336,27.139,46.44,54.686,46.44h27.705 c27.433,0,50.211-19.938,54.633-46.113l-68.48-11.693L187.462,424.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAEBC8"
    },
    d: "M301.42,346.839c-19.155,0-35.92,7.742-45.419,19.356c-9.499-11.614-26.265-19.356-45.419-19.356 c-29.645,0-53.677,18.486-53.677,41.29s24.032,41.29,53.677,41.29c19.155,0,35.92-7.742,45.419-19.356 c9.499,11.614,26.265,19.356,45.419,19.356c29.645,0,53.677-18.486,53.677-41.29S331.066,346.839,301.42,346.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4AF91"
    },
    d: "M298.017,437.411c-14.427,0-28.016-4.782-39.298-13.827c-1.597-1.282-3.831-1.282-5.444,0 c-11.274,9.044-24.863,13.827-39.29,13.827c-34.855,0-63.21-28.56-63.21-63.665c0-4.56,3.694-8.258,8.258-8.258 s8.258,3.698,8.258,8.258c0,26,20.944,47.149,46.694,47.149c10.629,0,20.645-3.524,28.96-10.198c7.694-6.161,18.427-6.161,26.105,0 c8.323,6.673,18.339,10.198,28.968,10.198c25.75,0,46.694-21.149,46.694-47.149c0-4.56,3.694-8.258,8.258-8.258 s8.258,3.698,8.258,8.258C361.227,408.851,332.872,437.411,298.017,437.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M211.445,361.269l17.541,14.625c15.648,13.046,38.383,13.046,54.03,0l17.541-14.624 c7.771-6.479,3.24-19.128-6.877-19.128c-22.403,0-52.954,0-75.358-0.001C208.205,342.141,203.674,354.79,211.445,361.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M256.001,214.71c-4.565,0-8.258-3.698-8.258-8.258v-67.419c0-4.56,3.694-8.258,8.258-8.258 s8.258,3.698,8.258,8.258v67.419C264.259,211.012,260.566,214.71,256.001,214.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M173.42,297.29L173.42,297.29c-13.682,0-24.774-11.092-24.774-24.774v-8.258 c0-13.682,11.092-24.774,24.774-24.774l0,0c13.682,0,24.774,11.092,24.774,24.774v8.258 C198.195,286.199,187.103,297.29,173.42,297.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M173.42,239.484v28.903c0,6.841,5.546,12.387,12.387,12.387c6.841,0,12.387-5.546,12.387-12.387 v-4.129C198.195,250.576,187.103,239.484,173.42,239.484z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 173.421,
    cy: 256,
    r: 8.258
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M338.582,297.29L338.582,297.29c-13.682,0-24.774-11.092-24.774-24.774v-8.258 c0-13.682,11.092-24.774,24.774-24.774l0,0c13.682,0,24.774,11.092,24.774,24.774v8.258 C363.356,286.199,352.264,297.29,338.582,297.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M338.582,239.484v28.903c0,6.841,5.546,12.387,12.387,12.387s12.387-5.546,12.387-12.387v-4.129 C363.356,250.576,352.264,239.484,338.582,239.484z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 338.581,
    cy: 256,
    r: 8.258
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M260.953,374.633l-17.542-20.173c-2.924-3.363-4.101-7.929-3.9-12.319c-7.473,0-14.69,0-21.189,0 c-10.117,0-14.648,12.649-6.878,19.128l17.541,14.625c11.942,9.957,27.993,12.257,41.891,7.016 C267.386,380.768,264.009,378.147,260.953,374.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5DCB4"
    },
    d: "M74.324,313.701c-0.376-1.501-0.68-3.363-0.95-5.388c-1.635,21.488-1.146,38.401,0.95,46.784 c3.617,14.469,23.889,35.438,52.017,53.458c-0.424-1.611-0.862-3.229-1.104-4.739c-1.26-7.866-1.661-21.163-1.104-38.088 C97.159,348.036,77.845,327.788,74.324,313.701z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLionUserIcon);
export default __webpack_public_path__ + "static/media/lion-user-icon.cfc0a04f83979aa8e1f27bf87be892f8.svg";
export { ForwardRef as ReactComponent };